module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASklEQVQ4y2P4jwQ+MAww7wADDNgPCh7QUcz/BwvvAP8fhsHA4/8PdNT///8HDQ8eSgPLA4cSSuoZQB7IUf//DA7eQOdiBG/wlHUAuzzAp4nTgyYAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTgtMDgtMTNUMTU6Mjc6MDgrMDk6MDAQgurLAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDEzLTEwLTA4VDA2OjA4OjIyKzA5OjAwP6gozQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01708_100x100.png
// module id = na08
// module chunks = 0